var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import MuiTabs from '@mui/material/Tabs';
import { useTabsContext } from '../tabs-context';
export var TabList = function (props) {
    var _a = useTabsContext(), onChange = _a.onChange, value = _a.value;
    var handleChange = function (_evt, newValue) {
        // onChange could be optional in react-router applications
        if (onChange) {
            onChange(newValue);
        }
    };
    return (React.createElement(MuiTabs, __assign({}, props, { onChange: onChange ? handleChange : undefined, value: value }), props.children));
};
